import { useEffect, useState } from "react";

const links = [
  { href: "#work", label: "Work" },
  { href: "#stats", label: "Impact" },
  { href: "#packages", label: "Packages" },
  { href: "#process", label: "Process" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAF9F6]/85 backdrop-blur-xl border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand"
          className="font-serif-editorial text-2xl md:text-[1.65rem] tracking-tight text-[#1A1A1A] leading-none"
        >
          Maison<span className="text-[#A89680]">·</span>Locale
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="hover-underline text-[13px] uppercase tracking-[0.22em] text-[#1A1A1A]/80 hover:text-[#1A1A1A]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta-book"
          className="hidden md:inline-flex items-center h-11 px-6 bg-[#1A1A1A] text-[#FAF9F6] text-[11px] tracking-[0.22em] uppercase font-medium hover:bg-[#A89680] transition-colors duration-500"
        >
          Book a Call
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5"
          aria-label="Menu"
        >
          <span
            className={`block h-px w-6 bg-[#1A1A1A] transition-transform duration-300 ${
              open ? "translate-y-[3px] rotate-45" : ""
            }`}
          />
          <span
            className={`block h-px w-6 bg-[#1A1A1A] transition-transform duration-300 ${
              open ? "-translate-y-[3px] -rotate-45" : ""
            }`}
          />
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-[#FAF9F6] border-t border-black/5"
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="text-[13px] uppercase tracking-[0.22em] text-[#1A1A1A]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta-book"
              className="inline-flex w-fit h-11 px-6 items-center bg-[#1A1A1A] text-[#FAF9F6] text-[11px] tracking-[0.22em] uppercase font-medium"
            >
              Book a Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
